var React = require('react');

function BgSocial (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.3904 14.0776C39.2305 20.8388 36.7655 27.808 31.8702 31.3793C26.975 34.916 19.58 35.02 12.4628 30.7899C5.34558 26.5598 -1.56333 17.9956 0.311447 11.1997C2.18623 4.40383 12.7753 -0.658417 21.1423 0.0697142C29.4747 0.797845 35.5851 7.31635 37.3904 14.0776Z","fill":"#F1F5FE"}));
}

BgSocial.defaultProps = {"width":"38","height":"34","viewBox":"0 0 38 34","fill":"none"};

module.exports = BgSocial;

BgSocial.default = BgSocial;
